import { AppContextType } from 'next/dist/shared/lib/utils';
import React from 'react';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import initApollo from './initApollo';

export default function withApollo(App: any) {
  return class WithApollo extends React.Component<any> {
    // eslint-disable-next-line react/static-property-placement
    static displayName = `WithApollo(${
      App.displayName || App.name || 'Component'
    })`;

    static async getInitialProps(appContext: AppContextType): Promise<any> {
      const {
        ctx: { req, res },
      } = appContext;

      const apollo = initApollo({});

      const extendedAppContext: AppContextType = {
        ...appContext,
        ctx: {
          ...appContext.ctx,
          apolloClient: apollo,
        },
      };

      let appProps = {};
      if (App.getInitialProps) {
        appProps = await App.getInitialProps(extendedAppContext);
      }

      if (res && res.finished) {
        // When redirecting, the response is finished.
        // No point in continuing to render
        return {};
      }

      return {
        ...appProps,
      };
    }

    apolloClient: ApolloClient<NormalizedCacheObject>;

    constructor(props: any) {
      super(props);
      // Initialize a fresh client for the browser
      this.apolloClient = initApollo({});
    }

    render() {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <App {...this.props} apolloClient={this.apolloClient} />;
    }
  };
}
